import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

import Prompt from 'components/Prompt'
import ErrorSnackbar from 'components/ErrorSnackbar'

export default o => (
	<MuiThemeProvider muiTheme={getMuiTheme(baseTheme)}>
		<div>
			<Prompt />
			<ErrorSnackbar />
			<div className='page-container layout'>
				<div className='view-container layout'>
					{o.children}
				</div>
			</div>
		</div>
	</MuiThemeProvider>
)



// WEBPACK FOOTER //
// ./src/components/layouts/CoreLayout.js